export function prizmToPx(n: number): string {
  return `${n || 0}px`;
}
